package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "tr")
val TrStrings = Strings(
    analyzer = "Analizör",
    appreciationOverview = "Değer Artışı Genel Bakış",
    chartLegendInterest = "Faiz",
    chartLegendPrincipal = "Anapara",
    chartXaxisMonths = "Aylar",
    chartYaxisPayment = "Ödeme",
    code = "tr",
    costOfCredit = "Kredi Maliyeti",
    creditDealAnalyzerDescription = "Kredi anlaşmanızın kapsamlı bir analizini almak için kredi ayrıntılarınızı girin. Analizörümüz, kredinizin gerçek maliyetini anlamanıza và bilinçli bir karar vermenize yardımcı olmak için temel ölçümleri değerlendirir.",
    detailsGoodRateLongTerm = "İyi oran ancak uzun vade yüksek toplam maliyete neden olur.",
    detailsHighApr = "Yüksek APR. ",
    detailsHighInterestCost = "Yüksek toplam faiz maliyeti.",
    detailsHighRateShortTerm = "Yüksek oran ancak kısa vade toplam maliyeti düşük tutar.",
    detailsLowApr = "Düşük APR. ",
    detailsLowInterestCost = "Düşük toplam faiz maliyeti.",
    discountsTradeIn = "İndirimler / Takas",
    displayName = "Türkçe",
    distribution = "Dağılım",
    downPayment = "Peşinat",
    effectiveApr = "APR",
    headerBalance = "Bakiye",
    headerDate = "Tarih",
    headerInterest = "Faiz",
    headerMonth = "#",
    headerPayment = "Ödeme",
    headerPrincipal = "Anapara",
    hideDetails = "Ayrıntıları Gizle",
    interest = "Faiz",
    invalidData = "Geçersiz Veri",
    loanAmountSupportingText = "Herhangi bir ek maliyet dahil toplam kredi tutarı.",
    loanDetails = "Kredi Ayrıntıları",
    paymentSupportingText = "Tahmini aylık ödemeniz.",
    paymentComposition = "Ödeme Bileşimi",
    percentSymbol = "%",
    principal = "Anapara",
    ratingBad = "Kötü Anlaşma",
    ratingExcellent = "Mükemmel Anlaşma",
    ratingFair = "Adil Anlaşma",
    ratingGood = "İyi Anlaşma",
    ratingPoor = "Zayıf Anlaşma",
    schedule = "Takvim",
    showDetails = "Ayrıntıları Göster",
    summaryBad = "Çok elverişsiz, mümkünse kaçının.",
    summaryExcellent = "Mükemmel finansal koşullar.",
    summaryFair = "Adil koşullar, pazarlık yapmayı düşünün.",
    summaryGood = "İyi koşullar, piyasa için standart.",
    summaryPoor = "Kötü koşullar, yüksek maliyet veya oran.",
    totalPaid = "Toplam Ödenen",
    lockTaxRate = "Vergi Oranını Kilitle",
    unlockTaxRate = "Vergi Oranının Kilidini Aç",
    currencySymbol = "₺",
    currency = "Para Birimi",
    totalCreditAmount = "Toplam Kredi Tutarı",
    taxAmount = "Vergi/Kesinti Tutarı",
    netAmountDisbursed = "Net Ödenen Tutar",
    years = "Yıl",
    loanTermTotalMonths = "Kredi Vadesi (Ay)",
    monthlyInstallment = "Aylık Taksit",
    principalInstallment = "Anapara Taksiti",
    otherFees = "Diğer Ücretler",
    insuranceCost = "Sigorta Primi",
    aprc = "Yıllık Maliyet Yüzdesi Oranı (APRC)",
    totalAmountPayable = "Ödenecek Toplam Tutar",
    prepaidFeeFixed = "İşlem Ücreti (Sabit Tutar)",
    prepaidFeePercentage = "İşlem Ücreti (Yüzde)",
    months = "Ay",
    description = "Bu analizör, bir kredi teklifinin sizin için uygun olup olmadığını değerlendirmenize yardımcı olur. Standart hesap makinelerinin aksine, faiz oranı girişi gerektirmez. Bunun yerine, ödemelere và ücretlere dayalı olarak APR'yi và toplam kredi maliyetini hesaplar, bir anlaşma derecelendirmesi và ayrıntılı grafikler sağlar.",
    agree = "Kabul Et",
    information = "Bilgi",
    errorCalculationOverflow = "Yıllık faiz oranı çok yüksek, hesaplama taşması.",
    errorTotalPaymentIsLessThanLoanAmount = "Alınan Tutar ödemesi kredi tutarından az.",
    errorDivisionByZero = "Sıfıra bölme",
    errorNegativeResult = "Negatif sonuç",
    errorRateTooHigh = "Oran çok yüksek",
    errorCalculation = "Lütfen doğru verileri girin",
    close = "Kapat",

    hi = "Merhaba",
    guest = "Misafir",
    account = "Hesap",
    signInWithGoogle = "Google ile giriş yap",
    signOut = "Çıkış yap",
    settings = "Ayarlar",
    about = "Hakkında",
    privacyPolicy = "Gizlilik Politikası",
    termsOfService = "Hizmet Şartları",
    language = "Dil",

    theme = "Tema",
    light = "Açık",
    dark = "Koyu",
    system = "Sistem",
    toggleExpand = "Genişlet/Daralt",
)
